var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_554",
    "data-name": "Group 554",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M9.85,17.7A7.85,7.85,0,1,1,17.7,9.85,7.849,7.849,0,0,1,9.85,17.7ZM5.925,9.85a3.925,3.925,0,0,0,7.85,0H12.2a2.355,2.355,0,0,1-4.71,0Z",
    transform: "translate(2.15 2.15)",
    fill: "#f5c839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProfileIcon);
export default __webpack_public_path__ + "static/media/activeProfileIcon.faabdf4f85110680f2d1c43943cd82bc.svg";
export { ForwardRef as ReactComponent };